 
import { styled } from '@eneco/sparky/stitches';

export const LogoWrapper = styled('div', {
  minHeight: '60px',
  paddingTop: '$1',

  // Temp override for the unnecessary <Bleed/> in the "Eneco's" logo component
  // <Bleed left={{ initial: '0', lg: '6' }} top={{ initial: '0', lg: '3' }}>
  // libs/sparky/src/components/Logo/Eneco/Logo.tsx
  '.sparky-bleed': {
    margin: '0',
  },

  // override Logo's <Wrapper/> to make sure that logo is aligned relative to
  // the screen's width
  div: {
    left: '50%',
    transform: 'translateX(-50%)',
    position: 'absolute',
  },
});
